import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="custom-dropdown"
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundCloseDropdown = this.closeDropdown.bind(this);
    document.addEventListener('click', this.boundCloseDropdown);
  }


  disconnect() {
    document.removeEventListener('click', this.boundCloseDropdown);
  }

  showDropdown(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle('show');
  }

  closeDropdown() {
    this.menuTarget.classList.remove('show');
  }
}
